import { useEngineModeSignal } from "../../../rx/signal/useEngineModeSignal"
import { freeze } from "../util/Object"
import type { Engine } from "./Engine.type"
import { EngineMode } from "./EngineMode/EngineMode.enum"

export default function garbageCollectEngine(engine: Engine): void {
  const [, setEngineMode] = useEngineModeSignal(engine)
  setEngineMode(EngineMode.None)
  engine.draftMove = null
  engine.state = {
    ...engine.state,
    ents: [],
    online: null,
  }

  // might catch/prevent member leaks.
  engine.gcELL().forEach((fn) => fn())
  const ell = engine.ofELL()
  ell.length = 0
  freeze(ell)
  freeze(engine)
}